import { AdminParameterCategory, AdminParameterPrimaryCategory } from 'types/admin/trackmanParameters';
import { Select } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

const paramCategories: Record<AdminParameterPrimaryCategory, string[]> = {
    "Tee-to-green": ['Club', 'Launch', 'Flight'],
    "Putting": ['Club', 'Launch', 'Roll', 'Green'],
    "Biomechanics": ['Alignment', 'Rotations', 'Translations', 'KinematicSequence']
}

export const ParameterCategories = observer(() => {
    const { t } = useTranslation();
    const ps = useStores().parametersStore;
    const primaryCategory = ps.parameter.primaryCategory;
    const currentCategory = paramCategories[primaryCategory].includes(ps.parameter.category) ? ps.parameter.category : paramCategories[primaryCategory][0];
  return (
    <div className='admin-edit-section'>
      <h2>Parameter categories</h2>
      <Select
        label='Category'
        className=''
              value={currentCategory}
              onChange={(event) => {
          if (paramCategories[primaryCategory].includes(event.target.value as AdminParameterCategory)) {
            ps.parameter.category = event.target.value as AdminParameterCategory;
          }
        }}
        selectOptions={paramCategories[primaryCategory].map((category) => {
            return {
                label: t(category, { ns: 'trackmanParameters' }),
                value: category,
            };
        })}
      />
    </div>
  );
});

export default ParameterCategories;
